export enum ApiErrorType {
  NotFound = 'notFound',
  AccessForbidden = 'accessForbidden',
  Internal = 'internal',
}
